(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eride-entretien"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('er-maint-guide')) {
  customElements.define('er-maint-guide', class extends HTMLElement {
    connectedCallback() {
      this.article = this.querySelector('.er-maint');
      this.abort?.abort();
      this.abort = new AbortController();
      this.dialog = this.querySelector('.er-maint-dialog');
      const opener = this.querySelector('.er-maint-guide-open');
      if (this.dialog && opener) {
        const options = {signal:this.abort.signal};
        const open = () => { if (!this.dialog.open) this.dialog.showModal(); };
        const close = () => { this.dialog.close(); opener.focus({preventScroll:true}); };
        opener.hidden = false;
        opener.addEventListener('click',open,options);
        this.querySelectorAll('.er-maint-guide-close,.er-maint-shop-dismiss').forEach(button=>button.addEventListener('click',close,options));
        this.dialog.addEventListener('click',event=>{
          if(event.target!==this.dialog)return;
          const rect=this.dialog.getBoundingClientRect();
          if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();
        },options);
        this.dialog.addEventListener('cancel',event=>{event.preventDefault();close();},options);
        if (!window.Shopify?.designMode && this.dialog.dataset.autoOpen === 'true') {
          const key='eride-guide:'+location.pathname+':'+(new URLSearchParams(location.search).get('q')||'');
          try { if(!sessionStorage.getItem(key)){open();sessionStorage.setItem(key,'1');} } catch { open(); }
        }
      }
      this.nav = this.querySelector('.er-maint-nav');
      if (!this.article || !this.nav) return;
      const options = {signal: this.abort.signal};
      this.links = [...this.nav.querySelectorAll('a[href^="#"]')];
      this.targets = this.links.map(link => document.getElementById(link.hash.slice(1)));
      this.checks = [...this.querySelectorAll('.er-maint-check input')];
      this.progress = this.querySelector('.er-maint-progress');
      this.reset = this.querySelector('.er-maint-reset');
      this.header = document.getElementById('header-group');
      this.measure = () => {
        const style = this.header ? getComputedStyle(this.header) : null;
        this.headerHeight = style && ['sticky','fixed'].includes(style.position) ? Math.max(0,this.header.offsetHeight + Math.min(0,parseFloat(style.top)||0)) : 0;
        const rootPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop)||0;
        this.article.style.setProperty('--em-header-offset',`${this.headerHeight}px`);
        this.article.style.setProperty('--em-anchor-offset',`${Math.max(0,this.headerHeight + this.nav.offsetHeight + 20 - rootPadding)}px`);
        this.highlight();
      };
      this.highlight = () => {
        let active = -1;
        const threshold = (this.headerHeight||0) + this.nav.offsetHeight + 45;
        this.targets.forEach((target,index) => {if (target && target.getBoundingClientRect().top <= threshold) active=index;});
        this.links.forEach((link,index) => {if(index===active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current');});
      };
      this.updateProgress = () => {
        if (!this.progress) return;
        const count = this.checks.filter(input=>input.checked).length;
        this.progress.hidden=false;
        this.progress.querySelector('progress').value=count;
        this.progress.querySelector('.er-maint-count').textContent=`${count} / ${this.checks.length}`;
        this.reset.hidden=count===0;
        this.checks.forEach(input=>input.closest('li').classList.toggle('is-complete',input.checked));
      };
      this.checks.forEach(input=>input.addEventListener('change',this.updateProgress,options));
      this.reset?.addEventListener('click',()=>{this.checks.forEach(input=>input.checked=false);this.updateProgress();this.checks[0]?.focus({preventScroll:true});},options);
      this.querySelectorAll('a[href^="#entretien-"]').forEach(link=>link.addEventListener('click',()=>{
        const target=document.getElementById(link.hash.slice(1));
        target?.focus({preventScroll:true});
      },options));
      this.onScroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.highlight();});};
      window.addEventListener('scroll',this.onScroll,{...options,passive:true});
      window.addEventListener('resize',this.measure,options);
      this.observer=new ResizeObserver(this.measure);
      this.observer.observe(this.nav);
      if(this.header)this.observer.observe(this.header);
      this.addEventListener('shopify:block:select',event=>{const details=event.target.closest('details');if(details)details.open=true;},options);
      this.measure();
      this.updateProgress();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eride-header"] && !Shopify.designMode) return;
  try {
    
const erHeaderGroup=document.getElementById('header-group');
if(erHeaderGroup&&!erHeaderGroup.dataset.compactReady){
  erHeaderGroup.dataset.compactReady='true';
  const erHeaderRow=erHeaderGroup.querySelector('.er-header-row');
  const updateErHeader=compact=>{
    erHeaderGroup.classList.toggle('is-compact',compact);
    if(compact)erHeaderGroup.querySelectorAll('details[open]').forEach(el=>el.removeAttribute('open'));
  };
  if(erHeaderRow){
    const erHeaderObserver=new IntersectionObserver(([entry])=>{
      updateErHeader(window.innerWidth>=801&&entry.intersectionRatio<.01);
    },{threshold:[0,.01]});
    erHeaderObserver.observe(erHeaderRow);
  }
}
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.er-header details[open]').forEach(el=>el.removeAttribute('open'));});
document.addEventListener('click',event=>{document.querySelectorAll('.er-header details[open]').forEach(el=>{if(!el.contains(event.target))el.removeAttribute('open');});});
document.querySelectorAll('.er-desktop-nav details').forEach(el=>el.addEventListener('toggle',()=>{if(el.open)document.querySelectorAll('.er-desktop-nav details').forEach(other=>{if(other!==el)other.open=false;});}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eride-vehicle-care"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('er-care-slider'))customElements.define('er-care-slider',class extends HTMLElement{
  connectedCallback(){
    this.slides=[...this.querySelectorAll('.ev-slide')];this.tabs=[...this.querySelectorAll('[data-slide-target]')];this.count=this.querySelector('.ev-slider-count span');this.bar=this.querySelector('.ev-slider-progress span');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.index=0;
    this.tabs.forEach((button,index)=>button.addEventListener('click',()=>this.go(index)));
    this.prev?.addEventListener('click',()=>this.go(this.index-1));this.next?.addEventListener('click',()=>this.go(this.index+1));
    this.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();this.go(this.index-1)}if(event.key==='ArrowRight'){event.preventDefault();this.go(this.index+1)}});
    let start=0;this.addEventListener('touchstart',event=>start=event.changedTouches[0].clientX,{passive:true});this.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-start;if(Math.abs(distance)>55)this.go(this.index+(distance<0?1:-1))},{passive:true});
    this.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.ev-slide');if(slide)this.go(this.slides.indexOf(slide))});this.go(0);
  }
  go(next){this.index=Math.max(0,Math.min(next,this.slides.length-1));this.slides.forEach((slide,index)=>{slide.hidden=index!==this.index;slide.toggleAttribute('data-active',index===this.index)});this.tabs.forEach((tab,index)=>tab.setAttribute('aria-selected',index===this.index));if(this.count)this.count.textContent=this.index+1;if(this.bar)this.bar.style.width=`${((this.index+1)/this.slides.length)*100}%`;if(this.prev)this.prev.disabled=this.index===0;if(this.next)this.next.disabled=this.index===this.slides.length-1;this.tabs[this.index]?.scrollIntoView({block:'nearest',inline:'nearest'})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
